import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import env from '../environment';
import request from '../utils/backend';
import roles from '../utils/roles';
import { Link } from 'react-router';
import { Badge, DropdownButton } from 'react-bootstrap';

import VersionMismatchModal from './VersionMismatchModal';

import approvedHourActions from '../actions/approvedHourActionCreators';
import floatingTaskActions from '../actions/floatingTaskActionCreators';
import notificationActions from '../actions/notificationActionCreators';
import tashiActions from '../actions/tashiActionCreators';

require.ensure([], () => {
    require('./Header.less');
});

class Header extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.props.dispatch(tashiActions.loadVersion());

        this.state = {
            activeTab: -1,
            expanded: false,
            dataLoaded: false
        };
    }

    // LIFECYCLE METHODS

    componentWillMount = () => { this.updateDimensions(); }

    componentDidMount = () => { window.addEventListener("resize", this.updateDimensions); }

    componentWillUnmount = () => { window.removeEventListener("resize", this.updateDimensions); }

    componentWillUpdate = (nextProps, nextState) => {
        if (!nextState.dataLoaded && nextProps.currentUser) this.loadData(nextProps.currentUser);
    }

    // EVENT HANDLERS

    handleLogout = () => {
        window.location = env.tashi + "/logout";
    }

    handleSelectNavitem = (index) => { this.setState({ expanded: false }); }

    handleToggle = () => { this.setState({ expanded: !this.state.expanded }); }

    // OTHER METHODS

    determineActiveTab = () => {
        let location = window.location.hash;
        let activeTab = -1;

        if (location.indexOf("logEntryAdder") !== -1)          activeTab = 1;
        else if (location.indexOf("logOverview") !== -1)       activeTab = 2;
        else if (location.indexOf("floatingTasks") !== -1)     activeTab = 3;
        else if (location.indexOf("pmo") !== -1)               activeTab = 4;
        else if (location.indexOf("pm") !== -1)                activeTab = 4;
        else if (location.indexOf("editLogs") !== -1)          activeTab = 7;
        else if (location.indexOf("approve") !== -1)           activeTab = 8;
        else if (location.indexOf("staffOverview") !== -1)     activeTab = 9;
        else if (location.indexOf("usersOverview") !== -1)     activeTab = 10;
        else if (location.indexOf("timesheetOverview") !== -1) activeTab = 11;
        else if (location.indexOf("pendingApprovals") !== -1)  activeTab = 12;
        else if (location.indexOf("export") !== -1)            activeTab = 14;

        return activeTab;
    }

    determineBrandStyle = () => {
        if (env.environment === 'dev')  return {backgroundColor: '#662200'};
        if (env.environment === 'test') return {backgroundColor: '#006622'};
        if (env.environment === 'osd')  return {backgroundColor: '#220066'};
    }

    loadData = (currentUser) => {
        this.loadFloatingTasks(currentUser);
        this.loadNumberOfUnapprovedHours(currentUser);
        this.loadnumberOfUnreadNotifications(this.props.numberOfNotificationsToLoad);

        this.setState({ dataLoaded: true });
    }

    loadFloatingTasks = (user) => {
        if (roles.userHasAnyOfRoles(user, ['PMO'])) {
            this.props.dispatch(floatingTaskActions.pmoLoadAll());
        } else if (roles.userHasAnyOfRoles(user, ['PM'])) {
            this.props.dispatch(floatingTaskActions.pmLoadAll());
        }
    }

    loadNumberOfUnapprovedHours = (user) => {
        if (roles.userHasAnyOfRoles(user, ['PM', 'LM'])) {
            this.props.dispatch(approvedHourActions.countUnapproved());
        }
    }

    loadnumberOfUnreadNotifications = (numberOfNotificationsToLoad) => {
        this.props.dispatch(notificationActions.loadUnreadPageCount(numberOfNotificationsToLoad));
    }

    updateDimensions = () => { this.setState({ width: window.innerWidth }); }

    // RENDER METHOD

    render = () => {
        if (!this.props.currentUser) return null;

        let activeTab = this.determineActiveTab();

        let brandStyle = this.determineBrandStyle();

        let numberOfUnreadNotificationsBadge = <Badge>{this.props.numberOfUnreadNotifications}</Badge>;

        let brand = (
            <Link title="Back to the main page" className="navbar-brand" to="notifications" >Tashi &nbsp; {this.props.numberOfUnreadNotifications > 0 ? numberOfUnreadNotificationsBadge : null}</Link>
        );

        let items = [];

        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['USER'])) {
            let dailyLogDescription = "Register work hours and open floating tasks";
            items.push(<li onClick={this.handleSelectNavitem} title={dailyLogDescription} key={1} id="1" className={activeTab === 1 ? "active" : ""}><Link to="logEntryAdder">Daily Log</Link></li>);
            let weeklyLogDescription = "Register and submit weekly timesheet";
            items.push(<li onClick={this.handleSelectNavitem} title={weeklyLogDescription} key={2} id="2" className={activeTab === 2 ? "active" : ""}><Link to="logOverview">Weekly Log</Link></li>);
        }

        let floatingTaskBadge = <Badge>{this.props.numberOfTasksToValidate}</Badge>;
        let weekApprovalBadge = <Badge>{this.props.numberOfUnapprovedHours}</Badge>;
        let floatingTasksDescription = "View and resolve floating tasks";
        let approvalDescription = "Timesheet approval";
        let staffOverviewDescription = "Timesheet insight for line manager";

        let administrationDescription = "Register projects and tasks";
        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM'])) {
            items.push(<li onClick={this.handleSelectNavitem} title={floatingTasksDescription} key={3} id="3" className={activeTab === 3 ? "active" : ""}><Link to="floatingTasks">Floating Tasks &nbsp; {this.props.numberOfTasksToValidate > 0 ? floatingTaskBadge : null}</Link></li>);
            if (!roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO']))
                items.push(<li onClick={this.handleSelectNavitem} title={administrationDescription}  key={4} id="4" className={activeTab === 4 ? "active" : ""}><Link to="pm">Project Management</Link></li>);
            items.push(<li onClick={this.handleSelectNavitem} title={approvalDescription} key={8} id="8" className={activeTab === 8 ? "active" : ""}><Link to="approve">Week Approval &nbsp; {this.props.numberOfUnapprovedHours > 0 ? weekApprovalBadge : null}</Link></li>);
        }

        const editLogsDescription = "Manage work logs for other users";
        const usersDescription = "Manage application users and their weekly quotas";
        const timesheetsDescription = "View and manage timesheets for other users";
        const pendingApprovalsDescription = "View pending approvals for project managers";
        const exportDescription = "Export filtered data into spreadsheets";

        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])) {
            if (!roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM']))
                items.push(<li onClick={this.handleSelectNavitem} title={floatingTasksDescription} key={3} id="3" className={activeTab === 3 ? "active" : ""}><Link to="floatingTasks">Floating Tasks &nbsp; {this.props.numberOfTasksToValidate > 0 ? floatingTaskBadge : null}</Link></li>);

            items.push(<li onClick={this.handleSelectNavitem} title={administrationDescription} key={4} id="4" className={activeTab === 4 ? "active" : ""}><Link to="pmo">Project Administration</Link></li>);
            items.push(<li onClick={this.handleSelectNavitem} title={editLogsDescription} key={7} id="7" className={activeTab === 7 ? "active" : ""}><Link to="editLogs">Edit Logs</Link></li>);
            items.push(<li onClick={this.handleSelectNavitem} title={usersDescription} key={10} id="10" className={activeTab === 10 ? "active" : ""}><Link to="usersOverview">Users</Link></li>);
            items.push(<li onClick={this.handleSelectNavitem} title={timesheetsDescription} key={11} id="11" className={activeTab === 11 ? "active" : ""}><Link to="timesheetOverview">Timesheets</Link></li>);
            items.push(<li onClick={this.handleSelectNavitem} title={pendingApprovalsDescription} key={12} id="12" className={activeTab === 12 ? "active" : ""}><Link to="pendingApprovals">Pending Approvals</Link></li>);
            items.push(<li onClick={this.handleSelectNavitem} title={exportDescription} key={14} id="14" className={activeTab === 14 ? "active" : ""}><Link to="export">Export</Link></li>);
        }

        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['LM'])) {
            if (!roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM'])) {
                items.push(<li onClick={this.handleSelectNavitem} title={approvalDescription} key={8} id="8" className={activeTab === 8 ? "active" : ""}><Link to="approve">Week Approval</Link></li>);
            }
        }

        if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['LM', 'CM'])) {
            items.push(<li onClick={this.handleSelectNavitem} title={staffOverviewDescription} key={9} id="9" className={activeTab === 9 ? "active" : ""}><Link to="staffOverview">Staff Overview</Link></li>);
        }

        if (this.state.width <= 768) {
            items.push(<li ref="logoutItem" key={13} id="13" title="Logout" onClick={this.handleLogout}><Link to="" >Logout</Link></li>);
        }

        let logoutWidth = (this.props.currentUser.givenName.length + this.props.currentUser.surname.length + this.props.currentUser.username.length + 4) * 18;

        return (
        <nav  style={brandStyle} className={items.length * 120 + logoutWidth >= this.state.width ? "collapsed navbar navbar-inverse navbar-fixed-top" : "navbar navbar-inverse navbar-fixed-top"}>
          <div className="container-fluid">

            { this.props.versionMismatch ? <VersionMismatchModal /> : null }
            <div className="navbar-header">
              <button onClick={this.handleToggle} type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              {brand}
            </div>

            <div ref="nav" className={this.state.expanded ? "navbar-collapse" : "collapse navbar-collapse"} id="bs-example-navbar-collapse-1">
                <ul className="nav navbar-nav">
                    { items }
                </ul>
                {
                    this.state.width > 768 ?
                    <ul ref="logoutItem" className="nav navbar-nav pull-right">
                        <DropdownButton id="headerDropdownButton" style={{"marginTop": "8px"}} className="dropdown pull-right" title={this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")"}>
                            <li role="presentation" className="">
                                <a href="#" tabIndex="-1" onClick={this.handleLogout}>Logout</a>
                            </li>
                        </DropdownButton>
                    </ul> : null
                }
            </div>
          </div>
        </nav>
        );
    }
}

Header.propTypes = {
    children: PropTypes.element,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    numberOfNotificationsToLoad: PropTypes.number,
    numberOfTasksToValidate: PropTypes.number,
    numberOfUnapprovedHours: PropTypes.number,
    numberOfUnreadNotifications: PropTypes.number,
    versionMismatch: PropTypes.bool
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        numberOfNotificationsToLoad: state.notifications.numberOfNotificationsToLoad,
        numberOfTasksToValidate: state.floatingTasks.adminFloatingTasks.length,
        numberOfUnapprovedHours: state.approvedHours.unapprovedHoursCount,
        numberOfUnreadNotifications: state.notifications.numberOfUnreadNotifications,
        versionMismatch: state.tashi.versionMismatch
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);



/** WEBPACK FOOTER **
 ** ./src/app/components/Header.js
 **/